import React from 'react';
import { closureLineColor } from '../../../constants/colors';
import AdmCumulativeChartWrapper from '../adm_shared/AdmCumulativeChartWrapper';

export default function AdmClosureCumulativeChart(props) {
  const { closure, increment, d0_interval, d2_interval } = props;

  return (
    <AdmCumulativeChartWrapper
      title='Cumulative Defect Closure'
      closure={closure}
      increment={increment}
      d0_interval={d0_interval}
      d2_interval={d2_interval}
      closureColor={closureLineColor}
      showArrival={false}
      showClosure={true}
    />
  );
}
